import { useContent } from "../content/ContentContext";

/**
 * Untitled moving tools strip (visual transition between About and My approach). Scrolls right-to-left,
 * duplicated so the loop is seamless. Pauses on hover; reduced-motion users see a static
 * wrapping row (handled in index.css via .marquee-static).
 */
export default function ToolsMarquee() {
  const { content } = useContent();
  const a = content.site.approach;
  const items = a?.tools?.length ? a.tools : [];

  const row = (hidden) => (
    <ul aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((t) => (
        <li key={t} className="flex items-center whitespace-nowrap">
          <span className="px-5 font-serif text-base text-ink sm:px-7 sm:text-xl">{t}</span>
          <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent/70" />
        </li>
      ))}
    </ul>
  );

  return (
    <section
      id="tools"
      data-testid="section-tools-marquee"
      aria-label="Tools and methods"
      className="scroll-mt-24 py-6 lg:py-8"
      style={{ background: "#FAF9F6" }}
    >
      <div
        data-testid="tools-marquee"
        className="marquee-wrap overflow-hidden border-y border-lavender py-4"
      >
        <div className="animate-marquee marquee-track flex w-max">
          {row(false)}
          {row(true)}
        </div>
        <ul className="marquee-static mx-auto hidden max-w-7xl flex-wrap items-center gap-x-2 gap-y-3 px-4 sm:px-6 lg:px-8" data-testid="tools-marquee-static">
          {items.map((t, i) => (
            <li key={t} className="flex items-center gap-2 font-serif text-base text-ink sm:text-lg">
              {t}
              {i < items.length - 1 && <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent/70" />}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
